export default "<ion-label> \n    {{ money }}\n    <!-- <ion-span>\n        77\n    </ion-span> -->\n\n</ion-label>\n";